/* src/app/shared/shop/product-card/product-card.component.scss */
.price-row {
  padding: 0 20px 20px 20px;
}
.addToCartButton {
  --background: #ff007f;
  --background-hover: #ff1f8f;
  --background-activated: #ee0077;
  --border-radius: 15px;
  font-size: 16px;
  font-family: "League Spartan", sans-serif;
  white-space: nowrap;
  margin: 0;
}
.addToCartButton::part(native) {
  padding: 15px;
}
.addToCartButton ion-icon:first-of-type {
  size: 10px !important;
  margin-right: 5px;
}
.addToCartButton ion-icon:last-of-type {
  size: 20px !important;
}
.add-to-cart-popover {
  --background: var(--background);
}
.card {
  border: 1px solid #cbcbcb;
  transition: box-shadow 0.2s ease-in-out;
}
.card:hover {
  box-shadow: 0px 10px 40px 0px rgba(0, 0, 0, 0.1490196078);
}
.clickable {
  transform: none !important;
  flex: 1 1 100%;
}
.cart-steps {
  padding: 20px 20px 20px 20px;
  flex: 1 0 100%;
  transition: flex 0.18s ease-out;
  background-color: white;
  height: 100%;
}
/*# sourceMappingURL=product-card.component-G4ZQEPFH.css.map */
